import { useMask } from "@react-input/mask"

const getInputWithSeparator = (
  inputCharacter: string,
  allowedSeparators: string[],
  defaultSeparator: string
) =>
  allowedSeparators.includes(inputCharacter)
    ? inputCharacter
    : defaultSeparator + inputCharacter

const useWtpNumberMask = () => {
  return useMask({
    mask: "________.___,___",
    replacement: {
      _: /[A-Za-z0-9]/,
      ".": /[-/]/, // Allow both '-' and '/' at first separator position
      ",": /-/, // Allow only '-' at second separator position
    },

    separate: true, // Don't shift characters on delete. Leave underscore in empty space

    // Handles either manual or automatic separator insertion
    track: ({ inputType, data, selectionStart, selectionEnd, value }) => {
      // Replace everything except separators with underscore when deleting
      if (inputType === "deleteBackward" || inputType === "deleteForward") {
        if (!value[selectionEnd]) return // Skip when deleting last character
        const chars = value.slice(selectionStart, selectionEnd)

        const replacedChars = chars.replace(/[A-Za-z0-9]/g, "_")

        return replacedChars
      }

      if (!data) return

      const uppercasedData = data.toUpperCase()

      if (selectionStart === 8)
        return getInputWithSeparator(uppercasedData, ["-", "/"], "-")

      if (selectionStart === 12)
        return getInputWithSeparator(uppercasedData, ["-"], "-")

      return uppercasedData
    },
  })
}

export default useWtpNumberMask
